import { i18n } from "services/i18nService";
import { formatNameLinkField } from "services/utility/formatting";
import { formatBooleanYesOrBlank } from "services/utility/formatting";

export const columnInfo = [
  {
    name: "name",
    fixed: true,
    heading: i18n("columns.Name"),
    formatFunc: formatNameLinkField,
    defaultSort: true,
    linkField: true,
    sortable: true,
  },
  {
    heading: i18n("columns.Description"),
    name: "description",
    sortable: true,
    fixedRightOfAction: true,
    fixed: true,
  },
  {
    name: "enabled",
    heading: i18n("columns.Enabled"),
    formatFunc: formatBooleanYesOrBlank,
    fixedRightOfAction: true,
    fixed: true,
  },
  {
    name: "billable",
    heading: i18n("columns.Billable"),
    formatFunc: formatBooleanYesOrBlank,
    fixedRightOfAction: true,
    fixed: true,
  },
];

const columnArray = Object.entries(columnInfo);
const defaultColumnInfo = columnArray.filter((col) => col[1].required);
export const defaultColumns = defaultColumnInfo.map((col) => col[0]);

export const LINE_ACTIONS = ["test", "delete"];
export const BATCH_ACTIONS = ["delete"];

export function getEmptyRecord() {
  return {
    name: null,
    description: null,
    enabled: true,
    billable: false,
    connectionType: OUTBOUND_CONNECTION_TYPE_OPTION.id,
    username: null,
    password: null,
    remoteHost: null,
    outboundRemotePath: null,
    inboundRemotePath: null,
  };
}

export const OUTBOUND_CONNECTION_TYPE_OPTION = {
  id: "Outbound",
  name: i18n("ftp.Outbound"),
};
export const INBOUND_CONNECTION_TYPE_OPTION = {
  id: "Inbound",
  name: i18n("ftp.Inbound"),
};
export const CONNECTION_TYPE_OPTIONS = [
  OUTBOUND_CONNECTION_TYPE_OPTION,
  INBOUND_CONNECTION_TYPE_OPTION,
  { id: "InOutBound", name: i18n("ftp.OutboundInbound") },
];
